import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { accountsURL, accountURL } from '@admin/config/routes';

interface IBreadcrumbsProps {
  account: {
    id: string | number;
    number: string;
    customer: {
      name: string;
    };
  };
  active?: string;
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ account, active }) => (
  <Breadcrumb>
    <Breadcrumb.Item>
      <NavLink to={accountsURL()}>Accounts</NavLink>
    </Breadcrumb.Item>
    <Breadcrumb.Item active={!active}>
      {active ? (
        <NavLink to={accountURL({ id: account.id })}>
          #{account.number} ({account.customer.name})
        </NavLink>
      ) : (
        <>
          #{account.number} ({account.customer.name})
        </>
      )}
    </Breadcrumb.Item>
    {active && <Breadcrumb.Item active>{active}</Breadcrumb.Item>}
  </Breadcrumb>
);
